import PortfolioSlider from './components/PortfolioSlider.svelte'
import Gallery from './components/gallery.svelte'
import Projects from './components/projects.svelte'
import baguetteBox from 'baguettebox.js'

var $ = window.jQuery

$(function () {
	var theme = window.aubuchonTheme || {}
	var scheduleIdleTask =
		theme.scheduleIdleTask ||
		(window.requestIdleCallback
			? function (callback) {
					return window.requestIdleCallback(callback, { timeout: 500 })
			  }
			: function (callback) {
					return window.setTimeout(callback, 1)
			  })
	var scheduleNextPaint =
		theme.scheduleNextPaint ||
		(window.requestAnimationFrame
			? function (callback) {
					return window.requestAnimationFrame(callback)
			  }
			: function (callback) {
					return window.setTimeout(callback, 16)
			  })
	var $body = $('body')

	$body.is('.page-template-gallery') && galleryPage()
	$body.is('.page-template-portfolio') && portfolioPage()
	initProjectsGallery()

	function galleryPage() {
		var portfolioSliderEl = document.getElementById('svelte-portfolio-slider')
		if (portfolioSliderEl && portfolioSliderEl.dataset.projects) {
			scheduleNextPaint(function () {
				new PortfolioSlider({
					target: portfolioSliderEl,
					props: {
						data: JSON.parse(portfolioSliderEl.dataset.projects),
					},
				})
			})
		}

		var $grid = $('.gallery-grid')
		var $gridFirstAnchor = $('.gallery-grid .grid-img-wrap a').first()

		if ($grid.length) {
			var Shuffle = window.Shuffle

			window.shuffleInstance = new Shuffle($grid[0], {
				itemSelector: '.grid-img-wrap',
				isCentered: false,
			})

			baguetteBox.run('.gallery-grid')

			$('.gal-tabs').on('click', 'button', function () {
				var $this = $(this)
				var gal = $this.text()
				$('.gal-tabs button').removeClass('active')
				$this.addClass('active')
				shuffleInstance.filter(gal)
			})

			if ($gridFirstAnchor.length) {
				$gridFirstAnchor[0].click()
			}
		}

		var galleryEl = document.getElementById('svelte-gallery')
		if (galleryEl && galleryEl.dataset.gallery) {
			scheduleIdleTask(function () {
				new Gallery({
					target: galleryEl,
					props: {
						data: JSON.parse(galleryEl.dataset.gallery),
					},
				})
			})
		}
	}

	function initProjectsGallery() {
		var projectsEl = document.getElementById('projects_gallery')
		if (projectsEl && projectsEl.dataset.projects) {
			scheduleIdleTask(function () {
				new Projects({
					target: projectsEl,
					props: {
						data: JSON.parse(projectsEl.dataset.projects),
					},
				})
			})
		}
	}

	function portfolioPage() {
		$(document).on('click', '.icon-360', showVirtualTour)
	}

	function showVirtualTour(event) {
		var $this
		var link
		var overlay
		var modal

		if ($(window).width() <= 950) {
			return
		}

		event.preventDefault()
		$this = $(event.currentTarget)
		link = $this.attr('href')
		overlay = document.createElement('div')
		modal = document.createElement('div')

		overlay.onclick = function () {
			this.className = this.className + ' close-modal'
			window.setTimeout(function () {
				document.body.removeChild(overlay)
			}, 300)
		}

		overlay.appendChild(modal)
		overlay.className = 'modal-overlay loading-background'
		modal.className = 'modal loading-background'
		modal.innerHTML =
			'<iframe class="lazyload" data-src="' +
			link +
			'" frameborder="0" width="935" height="800"></iframe>'
		document.body.appendChild(overlay)
	}
})